import { Box, Stack, Typography } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { alpha } from "@mui/material/styles";
import { grey } from "@mui/material/colors";
import {
  getDashboardColumns,
  dashboardColumnGroups,
} from "../constants";
import { HalftimeDashboardRow } from "../types";

export default function AdvancedBoxScoreTable({
  rows,
  teamAbbrev,
  logoUrl,
}: {
  rows: HalftimeDashboardRow[];
  teamAbbrev: string;
  logoUrl: string;
}) {
  return (
    <Box>
      <Stack sx={{ alignItems: "center", mb: 2 }}>
        <Box component="img" src={logoUrl} alt={teamAbbrev} sx={{ height: 48 }} />
        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
          {teamAbbrev}
        </Typography>
      </Stack>
      <DataGridPro
        rows={rows}
        columns={getDashboardColumns()}
        columnGroupingModel={dashboardColumnGroups}
        initialState={{
          sorting: {
            sortModel: [{ field: "totalPossessions", sort: "desc" }],
          },
          columns: {
            columnVisibilityModel: {
              totalPossessions: false,
            },
          },
        }}
        autoHeight
        hideFooter
        disableRowSelectionOnClick
        rowHeight={56}
        getRowClassName={(params) => (params.row.isTeam ? "TeamRow" : "")}
        sx={{
          "& .MuiDataGrid-row:nth-of-type(odd):not(.TeamRow)": {
            bgcolor: alpha(grey[500], 0.05),
          },
          "& .TeamRow": {
            fontWeight: 600,
            bgcolor: alpha(grey[500], 0.15),
          },
          "& .MuiDataGrid-columnHeader": {
            justifyContent: "center",
          },
          "& .MuiDataGrid-columnHeaderTitleContainer": {
            justifyContent: "center",
          },
          "& .MuiDataGrid-cell": {
            overflow: "visible",
            py: 0.5,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          "& .MuiDataGrid-cellContent": {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          "& .MuiDataGrid-cell[data-field='name']": {
            justifyContent: "flex-start",
          },
          "& .MuiDataGrid-cell[data-field='rim'], & .MuiDataGrid-cell[data-field='nonRimTwo'], & .MuiDataGrid-cell[data-field='threeCs'], & .MuiDataGrid-cell[data-field='threeNoncs'], & .MuiDataGrid-cell[data-field='threePtCrashes']":
            {
              fontWeight: 600,
            },
        }}
      />
    </Box>
  );
}
